import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "../../lib/LangContext";

export default function EditorialMarquee() {
  const { dict, isRTL } = useLang();
  return (
    <section
      data-testid="marquee-section"
      className="relative w-full bg-[#1A1918] text-[#F7F5F0] py-14 md:py-20 overflow-hidden"
    >
      <Marquee gradient={false} speed={22} pauseOnHover direction={isRTL ? "right" : "left"}>
        {dict.marquee_words.map((w, i) => (
          <span
            key={i}
            className="serif italic text-[10vw] md:text-[7.5vw] leading-none tracking-[-0.02em] px-10 flex items-center"
          >
            {w}
            <span className="mx-8 inline-block w-3 h-3 rounded-full bg-[#B56B45]" aria-hidden />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
